// extracted by mini-css-extract-plugin
export var caretIcon = "NavigationButton-module--caretIcon--mOp0E";
export var navigationButton = "NavigationButton-module--navigationButton--wiUKn";
export var open = "NavigationButton-module--open--WoCVO";
export var title = "NavigationButton-module--title--bT3wM";